import palette from '../palette'

export default {
  root: {
    '&$focused': {
      color: palette.text.main,
    },
  },
}
